<template>

  <vs-row
  vs-align="center"
  vs-type="flex" vs-justify="center" vs-w="12">
  <!-- {{bool}} -->
    <select v-model="bool"
    @change="update(params)"
      class="w-100 selectExample mt-2 customSelect">
      <option :key="index"
       :value="item.id" 
       :label="item.value"
        v-for="(item,index) 
        in boolList"
       class="selectOptionclass"/>
    </select>
  </vs-row>
</template>
<script>
import vSelect from 'vue-select'
import { LeadMixin } from './mixins/LeadMixin'
export default {
  components:{
    vSelect
  },
    mixins: [LeadMixin],
  data () {
    return {
      bool: null,
      
      addDetailsModal:false,
      leadFullDetails:'',
      leadform:{},
      lead_id:[],
      oldCountryID:'',
        boolList:[
            {
                id:1,
                value:'True'
            },
            {
                id:0,
                value:'False'
            }
        ],
    }
  },
  /*  created () {
  }, */
  mounted () {
    if(this.params.data[this.params.colDef.CellRendererParams]!=null){
       this.bool= this.params.data[this.params.colDef.CellRendererParams] && this.params.data[this.params.colDef.CellRendererParams]=="1"?1:0
    } else {
       this.bool= null
    }
   
    
  },

  methods: {
      async update(){
          const data = []
          data.leads_id = this.params.data.leads_id
          data.colId = this.params.column.colId
          data.fieldvalue = this.params.data[data.colId]?"0":"1"
          const index = this.params.rowIndex
          const oldValue = this.params.oldValue

          this.update_lead(data, index)
      },
  }
}
</script>
<style scoped>
  .customSelect {
    border-radius:3px;
    border: 1px solid #CCCCCC;
    width: 100%;
    height:30px;
    background-color: white;
    color:#757575
    /* font-family: $font-family-base'; */
  }
  .selectOptionclass :hover
  {
    background-color:yellow;
    color:white;
    border:none;
  }

</style>
